import { configureStore, combineReducers } from "@reduxjs/toolkit"
import basicInformation from "./slices/basicInformationSlice"
import moduleSlice from "./slices/moduleSlice"
import storage from "redux-persist/lib/storage"
import { persistReducer } from "redux-persist"

const persistConfig = {
  key: "root",
  storage,
}

const reducer = combineReducers({
  basicInformation: basicInformation,
  modulePermissions: moduleSlice,
})

const persistedReducer = persistReducer(persistConfig, reducer)

const store = configureStore({
  reducer: persistedReducer,
})

export default store
